import React from 'react';
import { IconProps } from './types';

const Check2: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 32 32"
  >
    <title />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M12.288 23.872v0c0.896 0.896 2.368 0.896 3.264 0l11.392-11.392c0.896-0.896 0.896-2.368 0-3.264v0c-0.896-0.896-2.368-0.896-3.264 0l-11.392 11.392c-0.896 0.896-0.896 2.368 0 3.264z"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M6.528 14.912v0c-0.896 0.896-0.896 2.368 0 3.264l5.696 5.696c0.896 0.896 2.368 0.896 3.264 0v0c0.896-0.896 0.896-2.368 0-3.264l-5.696-5.696c-0.896-0.896-2.368-0.896-3.264 0z"
    />
  </svg>
);

export default Check2;
